import React from "react";
import styled, { css } from "styled-components";
import { useTranslation } from "react-i18next";
import { createGRN } from "logic/permissions/GRN";
import useShowRouteFromGRN from "routing/hooks/useShowRouteFromGRN";
import { RestrictedAccessTooltip, Link } from "components/common";
import IconButton from "components/common/IconButton";
import useHasEntityPermissionByGRN from "hooks/useHasEntityPermissionByGRN";
const Container = styled.span(
  ({ theme }) => css`
    display: flex;
    padding: 10px;
    background-color: ${theme.colors.table.row.background};

    &:nth-of-type(even) {
      background-color: ${theme.colors.table.row.backgroundStriped};
    }
  `
);
const Header = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  margin-right: 5px;
`;
const Description = styled.span`
  flex: 2;
`;
const StyledDeleteButton = styled(IconButton)`
  flex: 0;
`;
const UserItemComponent = ({ onDeleteItem, item }) => {
  const { t } = useTranslation("enterprise_security");
  const entityGRN = createGRN("user", item.id);
  const entityRoute = useShowRouteFromGRN(entityGRN);
  const deleteButton = typeof onDeleteItem === "function" ? /* @__PURE__ */ React.createElement(
    StyledDeleteButton,
    {
      onClick: () => onDeleteItem(item),
      name: "close",
      title: t("team_details_user_item.remove", { name: item.name })
    }
  ) : null;
  const hasEditPermissions = useHasEntityPermissionByGRN(entityGRN, "edit");
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(Header, null, hasEditPermissions ? /* @__PURE__ */ React.createElement(Link, { to: entityRoute }, item.name) : /* @__PURE__ */ React.createElement(React.Fragment, null, item.name, /* @__PURE__ */ React.createElement(RestrictedAccessTooltip, { entityName: "user", capabilityName: "view" }))), /* @__PURE__ */ React.createElement(Description, null, item.description), deleteButton);
};
export default UserItemComponent;
